import { makeStyles } from '@material-ui/core/styles';
import {
  SET_COLLECTION_ORDER,
  SET_COLLECTION,
  useAccordionListDispatchContext,
  useAccordionListStateContext,
} from './AccordionListContext';

const getNextDirection = dir => {
  if (!dir || dir === 'desc') {
    return 'asc';
  }

  return 'desc';
};

export function useSortOnClick(attrName, orderable) {
  const context = useAccordionListStateContext();
  const {
    order: { direction: selectedDirection },
  } = context;
  const dispatch = useAccordionListDispatchContext();

  if (!attrName || !orderable) return null;

  return async () => {
    const order = {
      attrName,
      direction: getNextDirection(selectedDirection),
    };
    let sortedCollection;
    if (order.direction === 'asc') {
      sortedCollection = await context.collection.link('self').sortAscending(attrName).get();
    } else {
      sortedCollection = await context.collection.link('self').sortDescending(attrName).get();
    }
    dispatch({ type: SET_COLLECTION_ORDER, order });
    dispatch({ type: SET_COLLECTION, collection: sortedCollection });
  };
}

const useStyles = makeStyles(theme => ({
  col: {
    padding: theme.spacing(1),
    width: props => `1 / ${props.columnCount}`,
    maxWidth: props => `1 / ${props.columnCount}`,
    overflow: 'hidden',
    display: 'flex',
    flex: '1 1',
  },
}));

export function useColumnStyles() {
  const { schema } = useAccordionListStateContext();
  const schemaEntries = Object.entries(schema || {});
  const classes = useStyles({ columnCount: schemaEntries.length });

  return classes;
}
